import { create } from 'zustand';

type SuspensionState = {
  suspended: boolean;
  setSuspended: (suspended: boolean) => void;
};

/**
 * Set when any API call returns 403 ACCOUNT_SUSPENDED (the backend suspension
 * gate); cleared on the next successful response. A top-level component renders
 * the "account suspended" screen while this is true. In-memory only — a page
 * reload resets it, which is how a reactivated user gets back in.
 */
export const useSuspensionStore = create<SuspensionState>((set) => ({
  suspended: false,
  setSuspended: (suspended) => set({ suspended }),
}));
